<template>
  <div class="w-56 fixed top-3 right-3 flex flex-col gap-1 z-[1100]">
    <NotificationsItem
      v-for="(notification, index) in notificationsStore.notifications"
      :key="index"
      :notification="notification"
      :index="index" />
  </div>
</template>

<script setup lang="ts">
import useNotificationsStore from '@/store/notifications';
import NotificationsItem from '@/components/global/notifications/NotificationsItem.vue';

const notificationsStore = useNotificationsStore();
</script>
